import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDefaultRoute } from "../hooks/useDefaultRoute";
import { usePermissions } from "../hooks/usePermissions";

/**
 * Composant de page d'accueil intelligente
 * Redirige automatiquement vers la page la plus appropriée selon les permissions de l'utilisateur
 */
const SmartHome = () => {
  const navigate = useNavigate();
  const { user } = usePermissions();
  const { getPreferredRoute } = useDefaultRoute();

  useEffect(() => {
    if (user) {
      const preferredRoute = getPreferredRoute();

      // Rediriger vers la route préférée
      navigate(preferredRoute, { replace: true });
    }
  }, [user, navigate, getPreferredRoute]);

  // Cette page ne devrait pas être vue car elle redirige immédiatement
  // Mais on garde un fallback au cas où
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-amber-600 mx-auto mb-4"></div>
        <p className="text-gray-600">Chargement...</p>
      </div>
    </div>
  );
};

export default SmartHome;
